import { DefaultTheme } from 'styled-components'

const theme: DefaultTheme = {
  primary: "#F3B69B",
  background: "#FFF9F9",
  secondary: "#9ECBC2",
  tertiary: "#9ECBC2",
  textPrimary: "#0A4E66",
  textSecondary: "#FFF9F9",
  scale: {
    "01": "#252729",
    "02": "#B73C22",
    "03": "#E55B3D",
    "04": "#E5843D",
    "05": "#E5AC3D",
    "06": "#6DB2A2",
    "07": "#78D1CC",
    "08": "#73BEE8",
    "09": "#6296FC",
    "10": "#387CFF"
  }
};

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
}

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`
};

export default theme;
